import {ActiveStudent} from './active-student.model';
import {Attachment} from '../../shared-components/models/attachment.model';
import {Form} from './form.model';

export class FormPacket {

	// Shared Properties
	id: number;
	AdditionalStudentsAdded: boolean;
	CurrentUserMemberId: number;
	Id: number;
	FamilyId: number;
	LastUpdated = new Date('0001-01-01T00:00:00');
	Status: boolean;
	UserName: string;
	YearId: number;
	YearDescription: string;
	PrimaryParent: boolean;

    // Online Registration Only
	FormUpdated: boolean;
	OnlineRegistrationActiveStudents: ActiveStudent[];
	OnlineRegistrationAttachments: Attachment[];
	OnlineRegistrationForms: Form[];
	PacketRejected: boolean;
	QRFamily: boolean;
	SubmitMessageEnglish: string;
	SubmitMessageFrench: string;
	SubmitMessageSpanish: string;
	NewFamily: boolean;
	AssociatedToAllStudents: boolean;
	PacketIsReadyToSubmit: boolean;
	NoteForNonRes: boolean;

    // Parent Portal Only
	ParentPortalDataUpdateForms: Form[];

	// Class Functions
	constructor () {}

	// Methods
	getForms(onlineRegistration: boolean) {
		// PRE: online registration is true if this is for Online Registration
		// POST: returns the formPacket for the given use case
		if (onlineRegistration) {
			return this.OnlineRegistrationForms;
		} else {
			return this.ParentPortalDataUpdateForms;
		}
	}
}
